/* =========================================================
   Sopora — quick view
   Opens a modal built from the product JSON. Add-to-cart is
   handled by cart.js (delegated), so the injected form just works.
   ========================================================= */
(function () {
  'use strict';

  var modal = document.querySelector('[data-quick-view-modal]');
  if (!modal) return;
  var content = modal.querySelector('[data-qv-content]');
  var lastFocus = null;

  function money(cents) {
    var cfg = window.SoporaCart || {};
    var fmt = cfg.moneyFormat || '${{amount}}';
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, function (m, nd) { return nd ? whole : whole + '.' + parts[1]; });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function open() { lastFocus = document.activeElement; modal.hidden = false; document.body.style.overflow = 'hidden'; }
  function close() { modal.hidden = true; document.body.style.overflow = ''; content.innerHTML = '<div class="quick-view-modal__loading">Loading…</div>'; if (lastFocus) lastFocus.focus(); }

  function render(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var compare = p.compare_at_price_max || p.compare_at_price;
    var priceHtml = money(p.price) + (compare > p.price ? ' <s>' + money(compare) + '</s>' : '');
    var options = '';
    if (p.variants.length > 1) {
      options = '<select class="qv__select" name="id" aria-label="Variant">' + p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + ' — ' + money(v.price) + (v.available ? '' : ' (sold out)') + '</option>';
      }).join('') + '</select>';
    } else {
      options = '<input type="hidden" name="id" value="' + p.variants[0].id + '">';
    }
    var available = p.available;
    content.innerHTML =
      '<div class="qv__media">' + (img ? '<img src="' + encodeURI(img.replace(/^\/\//, 'https://')) + '" alt="' + esc(p.title) + '">' : '') + '</div>' +
      '<div class="qv__info">' +
        (p.vendor ? '<div class="qv__vendor">' + esc(p.vendor) + '</div>' : '') +
        '<h2 class="qv__title">' + esc(p.title) + '</h2>' +
        '<div class="qv__price">' + priceHtml + '</div>' +
        '<div class="qv__desc">' + (p.description || '') + '</div>' +
        '<form class="qv__form" data-product-form>' +
          options +
          '<input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="btn btn--primary qv__add"' + (available ? '' : ' disabled') + '>' + (available ? 'Add to basket' : 'Sold out') + '</button>' +
        '</form>' +
        '<a class="qv__full" href="' + encodeURI(p.url) + '">View full details &rarr;</a>' +
      '</div>';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      e.preventDefault();
      var url = trigger.getAttribute('data-quick-view');
      open();
      fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { window.location.href = url; });
      return;
    }
    if (e.target.closest('[data-qv-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

  // Close quick view once an add succeeds and the drawer opens
  document.addEventListener('submit', function (e) {
    if (e.target.closest('.qv__form')) { setTimeout(close, 300); }
  });
})();
